module.exports = __webpack_public_path__ + "img/white-sea-turtle.91767f83.jpg";